import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError as _throw } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Profile } from '@trade-platform/ui-shared';
import { getFromStorage } from '@trade-platform/ui-utils';
import { AixAuthService } from './auth-service';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
    private authService = inject(AixAuthService);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Kick user only if Profile is loaded, otherwise it's a 401 in the /me response and we have to show a modal
        // in the login component
        const profile = getFromStorage<Profile>('profile');
        return next.handle(request).pipe(
            catchError(err => {
                // Only a 401 means the session is dead. A 403 is an authenticated-but-forbidden
                // response (e.g. a feature-gated endpoint the tenant lacks, such as
                // GET /messaging/pending for orgs without sponsorMessaging) and must NOT end the
                // session — treating it as a logout dumped users on logout.html right after a
                // successful login (trade-platform/platform-operations#15666).
                if (err instanceof HttpErrorResponse && profile && err.status === 401) {
                    this.authService.callLogout(true);
                }
                return _throw(err);
            })
        );
    }
}
